const config = {
  env: 'DEV',
  PHONE: '',
  // env: "PROD"
  API: 'https://zapi.dtpsoft.vn/api/affiliate',
  API_V2: 'https://zapi.dtpsoft.vn/api/v2',
  HREF: 'https://teacher.dtpsoft.vn',
}
export default config

